import { ComingSoonContent } from '@azyntor-labs/nexus-ui';
import { Users, Target, TrendingUp } from 'lucide-react';

export const ComingSoonSimple = () => {
  return (
    <ComingSoonContent
      title="SOON"
      heading="We're Building Something Special"
      description="Our platform is getting a major upgrade. Stay tuned for an incredible learning experience powered by cutting-edge technology."
      showCountdown={true}
      countdownDays={45}
      showEmailSubscription={true}
      showFeatures={true}
      showBackLink={true}
      showBadge={true}
      badgeText="Something Amazing is Coming"
      showFloatingIcons={true}
      showCornerDecorations={true}
      // New features
      showProgress={true}
      progressPercent={75}
      progressLabel="Development Progress"
      showStats={true}
      stats={[
        { label: 'Active Users', value: '10K+', icon: Users },
        { label: 'Success Rate', value: '98%', icon: Target },
        { label: 'Growth', value: '+45%', icon: TrendingUp }
      ]}
      showSocialLinks={true}
      socialLinks={{
        twitter: 'https://twitter.com',
        github: 'https://github.com',
        linkedin: 'https://linkedin.com'
      }}
      onEmailSubscribe={async (_email) => {
        // Handle email subscription logic here
      }}
    />
  );
};

export default ComingSoonSimple;
